/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import Swal from 'sweetalert2'
import { Modal, Button } from 'react-bootstrap'
import { getRequestOptions, postRequestOptions } from '../helpers/Fetchwrapper'
import validationErrorMsg from '../helpers/ValidationErrorMsg'
import Spinner from 'react-bootstrap/Spinner'
import Select from 'react-select'

interface ItemCreateProps {
	show: boolean;
	handleClose: any;
	id: number;
}

interface InitialState {
	idItems: number | null;
	itemName: string;
	itemCode: string;
	idProjects: number | null;
	idUnits: number | null;
	isProduct: string;
	idItemCategories: number | null;
	remarks: string;
}


const ItemCreate: React.FC<ItemCreateProps> = ({ show, handleClose, id }) => {

	const [projects, setProjects] = useState([]);
	const [project, setProject] = useState({ label: 'Select Project', value: '' });
	const [units, setUnits] = useState([]);
	const [unit, setUnit] = useState({ label: 'Select Unit', value: '' });
	const [itemCategories, setItemCategories] = useState([]);
	const [itemCategory, setItemCategory] = useState({ label: 'Select Item Category', value: '' });
	const initialState: InitialState = {
		idItems: null,
		itemName: '',
		itemCode: '',
		idProjects: null,
		idUnits: null,
		isProduct: 'No',
		idItemCategories: null,
		remarks: '',
	};

	const [item, setItem] = useState(initialState);

	useEffect(() => {
		getAllProjects()
		getAllUnits()
		getAllItemCategories()
	}, [])

	useEffect(() => {
		if (id === 0) {
			setItem({ idItems: null, itemName: '', itemCode: '', idProjects: null, idUnits: null, isProduct: 'No', idItemCategories: null, remarks: '' });
			setProject({ label: 'Select Project', value: '' })
			setUnit({ label: 'Select Unit', value: '' })
			setItemCategory({ label: 'Select Item Category', value: '' })
		} else {
			fetch(
				process.env.REACT_APP_API_URL + 'items/' + id,
				getRequestOptions()
			)
				.then((resp) => {
					return resp.json()
				})
				.then((resp) => {
					setItem({ idItems: resp.data.idItems, itemName: resp.data.itemName, itemCode: resp.data.itemCode, idProjects: resp.data.idProjects, idUnits: resp.data.idUnits, isProduct: resp.data.isProduct, idItemCategories: resp.data.idItemCategories, remarks: resp.data.remarks || '' });
					setProject(resp.data.idProjects ? { label: resp.data.projectName, value: resp.data.idProjects } : { label: 'Select Project', value: '' })
					setUnit({ label: resp.data.unitName, value: resp.data.idUnits })
					setItemCategory({ label: resp.data.categoryName, value: resp.data.idItemCategories })
				})
				.catch((error) => {
					console.log(error, 'catch the hoop')
				})
		}
	}, [id]);

	const handleProjectChange = (project: any) => {
		setProject(project);
		setItem({ ...item, idProjects: project.id_projects });
	}

	const handleUnitChange = (unit: any) => {
		setUnit(unit);
		setItem({ ...item, idUnits: unit.id_units });
	}

	const handleItemCategoryChange = (itemCategory: any) => {
		setItemCategory(itemCategory);
		setItem({ ...item, idItemCategories: itemCategory.id_item_categories });
	}

	const getAllProjects = () => {
		fetch(
			process.env.REACT_APP_API_URL + 'projects',
			getRequestOptions()
		)
			.then((resp) => {
				return resp.json()
			})
			.then((resp) => {
				let projects = resp.data.map((item: any) => {
					item.label = item.project_name;
					item.value = item.id_projects;
					return item
				})
				setProjects(projects);
			})
			.catch((error) => {
				console.log(error, 'catch the hoop')
			})
	}

	const getAllUnits = () => {
		fetch(
			process.env.REACT_APP_API_URL + 'allUnits',
			getRequestOptions()
		)
			.then((resp) => {
				return resp.json()
			})
			.then((resp) => {

				let units = resp.map((item: any) => {
					item.label = item.unit_name;
					item.value = item.id_units;
					return item
				})
				setUnits(units);
			})
			.catch((error) => {
				console.log(error, 'catch the hoop')
			})
	}

	const getAllItemCategories = () => {
		fetch(
			process.env.REACT_APP_API_URL + 'allItemCategories',
			getRequestOptions()
		)
			.then((resp) => {
				return resp.json()
			})
			.then((resp) => {
				let itemCategories = resp.map((item: any) => {
					item.label = item.category_name;
					item.value = item.id_item_categories;
					return item
				})
				setItemCategories(itemCategories);
			})
			.catch((error) => {
				console.log(error, 'catch the hoop')
			})
	}


	const [isSubmitDisable, setSubmitDisable] = useState(false);
	const [loading, setLoading] = useState(false);

	const handleChange = (e: any) => {
		setItem({ ...item, [e.target.name]: e.target.value });
	};

	const itemSave = async (event: any) => {
		event.preventDefault()
		setSubmitDisable(true);
		setLoading(true);
		const confirm = await Swal.fire({
			title: 'Are you sure?',
			text: "You want to " + (id === 0 ? "create" : "update") + " this Item?",
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#ec008c',
			cancelButtonText: 'Cancel',
			confirmButtonText: 'Yes, Submit it!',
		})
		if (confirm.value) {
			const requestOptions = postRequestOptions(item)
			try {
				let url = (id === 0) ? `${process.env.REACT_APP_API_URL}items/store` : `${process.env.REACT_APP_API_URL}items/update`
				let response = await fetch(
					url,
					requestOptions
				)
				let respData = await response.json()
				if (respData.success === true) {
					const successMsg = respData.successMessage
					Swal.fire({
						icon: 'success',
						title: 'Success',
						text: successMsg,
					})
					handleClose(respData.success)
				} else {
					const errorsMessage = validationErrorMsg(respData.errors).join('<br>')
					Swal.fire({
						icon: 'error',
						title: 'Error',
						html: errorsMessage,
					})
				}
				setSubmitDisable(false);
				setLoading(false);
			} catch (error) {
				console.log(error, 'catch the hoop')
				setSubmitDisable(false);
			}
		}
	}


	return (
		<Modal show={show} onHide={() => handleClose(false)} size="lg">
			<form onSubmit={itemSave}>
				<Modal.Header closeButton>
					<Modal.Title>{id === 0 ? 'Create' : 'Edit'} Item</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="form-group row">
						<label htmlFor="idProjects" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Project <span className="required text-danger"></span></label>
						<div className="col-lg-5">
							<Select
								value={project}
								onChange={handleProjectChange}
								options={projects}
								menuPosition="fixed"
							/>
						</div>
					</div>
					<div className="form-group row">
						<label htmlFor="itemName" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Name <span className="required text-danger"></span></label>
						<div className="col-lg-5">
							<input type="text" name="itemName" id="itemName" value={item.itemName} onChange={handleChange} className="form-control form-control-sm" />
						</div>
					</div>
					{/* <div className="form-group row">
						<label htmlFor="itemCode" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Code <span className="required text-danger"></span></label>
						<div className="col-lg-5">
							<input type="text" name="itemCode" id="itemCode" value={item.itemCode} onChange={handleChange} className="form-control form-control-sm" />
						</div>
					</div> */}
					<div className="form-group row">
						<label htmlFor="idUnits" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Unit <span className="required text-danger"></span></label>
						<div className="col-lg-5">
							<Select
								value={unit}
								onChange={handleUnitChange}
								options={units}
								menuPosition="fixed"
							/>
						</div>
					</div>

					<div className="form-group row">
						<label htmlFor="idItemCategories" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Item Category <span className="required text-danger"></span></label>
						<div className="col-lg-5">
							<Select
								value={itemCategory}
								onChange={handleItemCategoryChange}
								options={itemCategories}
								menuPosition="fixed"
							/>
						</div>
					</div>

					<div className="form-group row">
						<label htmlFor="remarks" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Remarks</label>
						<div className="col-lg-5">
							<textarea name="remarks" id="remarks" value={item.remarks || ''} onChange={handleChange} className="form-control form-control-sm" rows={3}></textarea>
						</div>
					</div>

					{/* <pre>{JSON.stringify(item, null, 2)}</pre> */}
				</Modal.Body>
				<Modal.Footer>

					<button type="submit" disabled={isSubmitDisable || loading} className="btn btn-sm btn-primary me-2">
						{loading &&
							<Spinner
								as="span"
								animation="grow"
								size="sm"
								role="status"
								aria-hidden="true"
							/>
						}
						<span>  Submit</span>
					</button>
					<Button variant='secondary' size="sm" onClick={() => handleClose(false)}>
						Close
					</Button>
				</Modal.Footer>
			</form>
		</Modal>
	)
}

export default ItemCreate
